<template>
    <div>
        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0 d-block d-sm-inline-block">
                <template v-if="( $store.state.user.permissions.length === 0 || ($store.state.user.permissions.length === 1 && $store.state.user.permissions[0] === 'correctiveActions.view.assigned') )">
                    <li class="breadcrumb-item font-weight-light d-block d-sm-inline-block">
                        <router-link :to="`/`"><i class="fa fa-dashboard"></i> Dashboard</router-link>
                    </li>
                </template>
                <template v-else>
                    <template v-if="action.asset_type == 'InspectionResult'">
                        <li class="breadcrumb-item font-weight-light d-block d-sm-inline-block">
                            <router-link to="/inspections">
                                <i class="fa fa-list"></i> Inspections
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light d-block d-sm-inline-block mt-md-0 mt-2">
                            <router-link :to="`/inspections/view/${action.asset.InspectionId}`">
                                {{ action.asset.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light d-block d-sm-inline-block mt-md-0 mt-2">
                            <router-link :to="`/inspections/result/${action.asset_id}`">
                                <template v-if="action.result">
                                    {{ action.result.sectionDisplayOrder }}.{{ action.result.DisplayOrder }} {{ action.result.ElementText }}
                                </template>
                                <template v-else>
                                    Result {{ action.asset_id }}
                                </template>
                            </router-link>
                        </li>
                    </template>

                    <template v-else>
                        <li class="breadcrumb-item font-weight-light d-block d-sm-inline-block">
                            <router-link :to="`/${action.asset_type.toLowerCase()}s`">{{ action.asset_type }}s</router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-light d-block d-sm-inline-block mt-md-0 mt-2">
                            <router-link :to="`/${action.asset_type.toLowerCase()}s/view/${action.asset_id}`">
                                {{ action.asset.name }}
                            </router-link>
                        </li>
                    </template>
                </template>

                <li :class="{'breadcrumb-item': true, 'active d-block d-sm-inline-block mt-2': (mode == 'View' || mode == 'Complete'), 'font-weight-light': (mode != 'View')}">
                    <template v-if="mode != 'View'">
                        <router-link :to="`/corrective-actions/view/${action.corrective_action_id}`">CA-{{ action.corrective_action_id }}</router-link>
                    </template>
                    <template v-else>
                        CA-{{ action.corrective_action_id }}
                    </template>
                </li>

                <li :class="{'breadcrumb-item d-block d-sm-inline-block mt-md-0 mt-2': true, 'active': (mode != 'View')}" v-if="mode != 'View'">
                    <i class="fa fa-edit" v-if="mode == 'Edit'"></i>
                    <i class="fa fa-flag-checkered" v-if="mode == 'Complete'"></i>
                    <i class="fa fa-trash" v-if="mode == 'Delete'"></i>
                    {{ mode }}
                </li>
            </ol>
        </h4>
    </div>
</template>

<script>
    export default {
        props: ['action', 'mode'],

        data: function() {
            return {

            }
        },

        methods: {

        },

        mounted() {
            console.log(this.$store.state.user.permissions.length);
        }
    }
</script>
